import React from "react";

const Tabs = ({ children }) => {
    return <ul className="SubMenu u-mb-md">{children}</ul>;
};

export default Tabs;
